import React, {
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  ReactNode,
  useMemo,
} from 'react';

type CarouselContextType = {
  prefixFindingMethod?: string;
  carouselFindingMethod?: string;
  carouselTitle?: string;
  setCarouselTitle: Dispatch<SetStateAction<string>>;
  setCarouselFindingMethod: Dispatch<SetStateAction<string>>;
  productFindingMethod?: string;
  isProductFindingMethodReady?: boolean;
  setExperience: Dispatch<SetStateAction<string>>;
};

const CarouselContext = createContext<CarouselContextType>({
  setCarouselTitle: () => {},
  setCarouselFindingMethod: () => {},
  productFindingMethod: '',
  setExperience: () => {},
});

const CarouselProvider = ({ children }: { children: ReactNode }) => {
  const [prefixFindingMethod] = useState('');
  const [carouselTitle, setCarouselTitle] = useState('');
  const [experience, setExperience] = useState('');
  const [carouselFindingMethod, setCarouselFindingMethod] = useState('');

  const isProductFindingMethodReady = useMemo(
    () => !!(carouselFindingMethod && carouselTitle),
    [carouselFindingMethod, carouselTitle],
  );

  const productFindingMethod = useMemo(
    () =>
      experience.length
        ? `${prefixFindingMethod} - ${carouselTitle} - ${experience} - ${carouselFindingMethod}`
        : `${prefixFindingMethod} - ${carouselTitle} - ${carouselFindingMethod}`,
    [prefixFindingMethod, experience, carouselFindingMethod, carouselTitle],
  );

  return (
    <CarouselContext.Provider
      value={{
        prefixFindingMethod,
        carouselTitle,
        carouselFindingMethod,
        setCarouselTitle,
        setCarouselFindingMethod,
        productFindingMethod,
        isProductFindingMethodReady,
        setExperience,
      }}
    >
      {children}
    </CarouselContext.Provider>
  );
};

export { CarouselProvider };
export default CarouselContext;
